import { render, staticRenderFns } from "./block-profile-api-keys-form.vue?vue&type=template&id=62956d84&scoped=true&lang=pug"
import script from "./block-profile-api-keys-form.vue?vue&type=script&lang=js"
export * from "./block-profile-api-keys-form.vue?vue&type=script&lang=js"
import style0 from "./block-profile-api-keys-form.vue?vue&type=style&index=0&id=62956d84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62956d84",
  null
  
)

export default component.exports